import React from "react";
import { useLocation } from "react-router-dom";
import api from "../api/http";               // your axios instance
import { API_ENDPOINTS } from "../api/endpoints";

export default function SettingsBank() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const linked = params.get("linked");
  const error = params.get("error");

  const start = async () => {
    try {
      // This XHR WILL send Authorization header (from http.js interceptor)
      const res = await api.get(API_ENDPOINTS.BANK_OAUTH_START_URL);
      const url = res.data?.url;
      if (!url) throw new Error("No url returned from start-url");
      window.location.href = url; // go to GMO login page
    } catch (e) {
      console.error("Connect bank failed", e);
      alert("Connect bank failed. Check console/network.");
    }
  };

  return (
    <div className="bank-settings-page" style={{ maxWidth: 720, margin: "40px auto", padding: 16 }}>
      <h2>銀行口座連携</h2>

      {linked === "1" && (
        <div style={{ padding: 12, marginTop: 12, border: "1px solid #2ecc71" }}>
          ✅ 連携完了
        </div>
      )}

      {linked === "0" && (
        <div style={{ padding: 12, marginTop: 12, border: "1px solid #e74c3c" }}>
          ❌ 連携失敗: {error || "unknown"}
        </div>
      )}

      <p style={{ marginTop: 16 }}>
        自動引き落としのために銀行口座の連携が必要です。
      </p>

      <button
        onClick={start}
        className="button button-primary"
        style={{ marginTop: 12 }}
      >
        銀行口座を連携（Connect Bank）
      </button>
    </div>
  );
}
